import axios from 'axios'
import { enqueueSnackbar } from "notistack";
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { API } from "../../../helpers/constants";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import { useMuiGridServerSide } from "../../../hooks/muiGrid/useMuiGridServerSide";
import { SPECIALTIES } from "../locales/namespaces";

const useSpecialties = () => {
	const { t } = useTranslation(SPECIALTIES)
	const [updateGridSource, setUpdateGridSource] = useState(false)
	const [loading, setLoading] = useState(false)
	const [updateCost, setUpdateCost] = useState(false)
	
	// const {isLoading, data, refreshGrid} = useMuiGridServerSide({
	// 	url: `${API}/en/fts/costs/index`,
	// 	initialPageSize: 50,
	// 	initialSortModel: [{name: 'id', direction: 'descending'}]
	// })
	const {
		isLoading,
		data,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
		refreshGrid
	} = useMuiGridServerSide({
		url: `parameters/materials/skills/index`,
		initialPageSize: 50,
		initialSortModel: [{ name: 'id', direction: 'descending' }]
	})
	
	const store = (newRow) => {
		axios.post(`${API}/en/parameters/materials/skills/store`, { id:newRow.id, Description:newRow.Description }).then(res => {
			enqueueSnackbar(t('Specialty created successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			refreshGrid()
			setUpdateCost(!updateCost)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
		})
		refreshGrid()
	}
	const update = (newRow, oldRow) => {
		axios.post(`${API}/en/parameters/materials/skills/update`, { id:newRow.id, Description:newRow.Description }).then(response => {
			enqueueSnackbar(t('Specialty updated successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			refreshGrid()
			setUpdateCost(!updateCost)
		}).catch(error => {
			
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
			
			refreshGrid()
		})
	}
	const remove = (row) => {
		axios.post(`${API}/en/parameters/materials/skills/remove`, { id: row }).then(res => {
			enqueueSnackbar(t('Specialty deleted successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			refreshGrid()
			setUpdateCost(!updateCost)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
		})
	}
	
	return {
		data,
		isLoading,
		refreshGrid,
		loading,
		store,
		remove,
		update,
		updateGridSource,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
	}
}
export default useSpecialties